import { AgGridReact } from "ag-grid-react";
import { defaultColDef, getRowId, themeColumns } from "../../utils/gridHelper";
import { useCallback, useEffect, useMemo, useState } from "react";

import { useStore } from "../../hooks/store";

import ThemeForm from "../Form/ThemeForm/ThemeForm";
import GridToolBar from "../GridToolBar";
import { deleteTheme, getTheme } from "../../utils/API/themeMethods";

export function ThemeGrid() {
  const store = useStore();
  const [gridData, setGridData] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [quickFilterText, setQuickFilterText] = useState("");
  const [themeData, setThemeData] = useState(undefined);

  const fetchThemeData = () => {
    getTheme().then(({ data }) => {
      setGridData(data);
    });
  };

  const handleAddOpener = () => {
    store.setForm(<ThemeForm />, fetchThemeData);
  };

  const handleRedactOpener = () => {
    store.setForm(<ThemeForm />, fetchThemeData, themeData);
  };

  const handleDelete = async () => {
    const { id } = themeData;
    const deletedTheme = await deleteTheme(id);
    if (deletedTheme.status !== 200) {
      store.setAlert(deletedTheme.data, "error");
      return;
    }
    fetchThemeData();
  };

  const onGridReady = useCallback((e) => {
    // сохраняем АПИ
    setGridApi(e.api);
    fetchThemeData();
  }, []);

  //Отслеживаем изменение текста для фильтра, устанавливаем соответстствующий фильтр в грид
  useEffect(() => {
    gridApi?.setGridOption("quickFilterText", quickFilterText);
  }, [quickFilterText, gridApi]);

  //выбор конрентной строки
  const rowSelection = useMemo(() => {
    return {
      mode: "singleRow",
      checkboxes: true,
      enableClickSelection: true,
    };
  }, []);

  const rowClickHandler = (e) => {
    e.data && setThemeData(e.data);
  };

  return (
    <div style={{ maxWidth: "100%", height: "100%" }}>
      <GridToolBar
        filter={true}
        onAdd={handleAddOpener}
        onRefresh={fetchThemeData}
        onDelete={handleDelete}
        onUpdate={handleRedactOpener}
        filterValue={quickFilterText}
        filterOnChange={setQuickFilterText}
        dataToAction={themeData}
      />
      <AgGridReact
        onGridReady={onGridReady}
        onRowClicked={rowClickHandler}
        gerRowId={getRowId}
        rowData={gridData}
        defaultColDef={defaultColDef}
        tooltipShowDelay={500}
        rowSelection={rowSelection}
        columnDefs={[...themeColumns]}
      />
    </div>
  );
}
